import React from 'react';

const TopBanner = () => {
    return (
        <div>
            <div className="flex bg-white flex-col md:flex-row gap-2 justify-between items-center mx-auto w-full">
                <div className="w-full order-2 md:order-1 space-y-4 md:w-3/6 mx-auto">
                    <div className="flex justify-start gap-2 px-5 py-1 w-2/3 items-center">
                        <div className="flex py-1 px-3 gap-2 bg-[#fce5b8]">
                            <img src="https://d33wubrfki0l68.cloudfront.net/94b287d426cc7d337643ba702b46787fd75e9bb9/3aab2/assets/images/hero-icon.svg" alt="" className="" />
                            <h3 className="font-bold capitalize text-xs md:text-md">Fastest Delivery Guaranteed</h3>
                        </div>
                    </div>
                    <div className="px-5">
                        <h1 className="text-4xl md:text-7xl fw-bold" style={{ fontFamily: "Rajdhani" }}>Welcome to <br /> <span className="text-[#FFA800]">KHADOK</span> <br /> Restaurant</h1>
                    </div>
                    <div className="px-5">
                        <p className="">Get 10% instant off for all order and $200 signup bonus today for new registration!</p>
                    </div>
                </div>
                <div className="w-full order-1 md:order-2 md:w-3/6 mx-auto p-10 overflow-hidden">
                    <img draggable="false" style={{animation: `spin 60s linear infinite`,transform: `rotate(${Math.floor(Math.random() * (361))}deg)`}} src="https://www.freepnglogos.com/uploads/food-png/food-indian-take-away-the-amantola-39.png" alt="" className="object-cover" />
                </div>
            </div>
        </div>
    );
};

export default TopBanner;